<template>
  <section>
    <h3 v-if="comments.length < 1" class="py-4">No Comments</h3>
    <div class="row mx-0">
      <div
        class="col-4"
        v-for="(item, idx) in commentArrays"
        :key="'comment-section' + idx"
      >
        <div v-for="(comment, index) of item" :key="'comment-1-' + index">
          <comment-box :commentData="comment"></comment-box>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CommentBox from "./comment-box.vue";
export default {
  components: { CommentBox },
  props: {
    comments: {
      type: Array,
      required: true,
    },
  },
  computed: {
    commentArrays() {
      let subArrayLength = Math.ceil(this.comments?.length / 3);
      return this.splitIntoSubArray(this.comments, subArrayLength);
    },
  },
  methods: {
    splitIntoSubArray(arr, count) {
      var newArray = [];
      while (arr.length > 0) {
        newArray.push(arr.splice(0, count));
      }
      return newArray;
    },
  },
};
</script>

<style lang="scss" scoped>
section {
  overflow: auto;
}
</style>
